module.exports = __webpack_public_path__ + "files/20cf7f28a52fb3560694989e49fff18d.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/exo2-bolditalic-webfont.ttf
// module id = 671
// module chunks = 60